import React, { useState } from "react";
import classNames from "classnames";
import { resizeImage } from "@lib/helpers";

import Lightbox from "@components/Lightbox";
import InLightboxGallery from "@components/ProductMedia/InLightboxGallery";

const GalleryBlock = ({ picked, alignCenter }) => {
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const images = picked.map((image) => {
    return {
      file: `${image.path}${image.name}`,
    };
  });
  const galleryClass = classNames("js-cms-gallery", {
    "u-text-align-center": alignCenter,
  });

  const toggleLightbox = () => {
    setIsLightboxOpen(!isLightboxOpen);
  };

  const handleImageClick = (event, index) => {
    event.preventDefault();
    setCurrentGallerySlide(index);
    setIsLightboxOpen(true);
  };

  return (
    <>
      <div className={galleryClass}>
        <ul className="List List--inline List--noMargin">
          {images.map((image, index) => (
            <li key={image.file}>
              <a
                className="u-display-block u-border-solid"
                href="#"
                onClick={(event) => handleImageClick(event, index)}
              >
                <img
                  className="u-display-block"
                  src={resizeImage(image.file, "100x100")}
                  width={100}
                  height={100}
                  alt=""
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
      <Lightbox active={isLightboxOpen} onCloseRequest={toggleLightbox}>
        <InLightboxGallery
          title=""
          images={images}
          currentSlide={currentGallerySlide}
          onSlideChange={setCurrentGallerySlide}
          inLightbox={true}
        />
      </Lightbox>
    </>
  );
};

export default GalleryBlock;
